<template>
  <div class="text-area">
    <p v-if="$slots.default" class="custom-font">
      <slot></slot>
    </p>
    <div class="q-gutter-sm radio">
      <q-radio
        v-for="(item, index) in items"
        :key="index"
        v-model="model"
        keep-color
        dense
        :val="item.value"
        :label="item.label"
        color="secondary"
        @click="optionalUncheck(item.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "InputRadio",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    optional: {
      type: Boolean,
      required: false,
    },
    mainColor: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
    textFont: {
      type: String,
      default: "null",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    optionalUncheck(val) {
      if (this.optional && val === this.modelValue) {
        this.model = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./inputs";

.input-form {
  border: 1px solid v-bind(mainColor);
  background-color: v-bind(backgroundColor);
}

.custom-font {
  font-family: v-bind(textFont), "Petit Formal Script", serif;
}
</style>
